// src/components/SessionManager.js
import { useEffect, useRef } from "react";
import { useAuth } from "../auth/AuthContext";
import { useWebSocketActions } from "../context/WebSocketContext";

const SessionManager = () => {
  const { isAuthenticated } = useAuth();
  const { startWebSocket, stopWebSocket } = useWebSocketActions();
  const prevAuthRef = useRef(null);

  useEffect(() => {
    // Evita reconectar si el estado no ha cambiado
    if (prevAuthRef.current === isAuthenticated) return;

    if (isAuthenticated) {
      startWebSocket();
    } else {
      stopWebSocket();
    }

    prevAuthRef.current = isAuthenticated;
  }, [isAuthenticated, startWebSocket, stopWebSocket]);

  return null;
};

export default SessionManager;
